import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Box, IconButton, TextField, Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import { toast } from "react-toastify";

const toLatLng = (xPoint, yPoint) => {
  const lat = Number(xPoint);
  const lng = Number(yPoint);
  if (!Number.isFinite(lat) || !Number.isFinite(lng) || lat === 0 || lng === 0) {
    return null;
  }
  return { lat, lng };
};

export const buildGoogleMapsLink = (xPoint, yPoint) => {
  const p = toLatLng(xPoint, yPoint);
  return p ? `https://www.google.com/maps?q=${p.lat},${p.lng}` : "";
};

export const buildNeshanLink = (xPoint, yPoint) => {
  const p = toLatLng(xPoint, yPoint);
  return p ? `https://neshan.org/maps/@${p.lat},${p.lng},17z,0p` : "";
};

const copyText = async (text) => {
  if (navigator.clipboard && window.isSecureContext) {
    await navigator.clipboard.writeText(text);
    return;
  }
  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.setAttribute("readonly", "");
  textarea.style.position = "fixed";
  textarea.style.opacity = "0";
  document.body.appendChild(textarea);
  textarea.select();
  try {
    if (!document.execCommand("copy")) throw new Error("copy failed");
  } finally {
    document.body.removeChild(textarea);
  }
};

const LinkRow = ({ label, link, size, copiedMessage }) => {
  const handleCopy = async () => {
    try {
      await copyText(link);
      toast.success(copiedMessage);
    } catch {
      toast.error("کپی ناموفق بود.");
    }
  };

  return (
    <Box sx={{ display: "flex", gap: 0.5, alignItems: "center" }}>
      <TextField
        label={label}
        value={link}
        size={size}
        fullWidth
        InputProps={{ readOnly: true }}
        inputProps={{ dir: "ltr" }}
        onFocus={(e) => e.target.select()}
      />
      <Tooltip title="کپی لینک">
        <IconButton color="primary" onClick={handleCopy}>
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title="باز کردن در نقشه">
        <IconButton
          color="primary"
          component="a"
          href={link}
          target="_blank"
          rel="noopener noreferrer"
        >
          <OpenInNewIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

LinkRow.propTypes = {
  label: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  size: PropTypes.string,
  copiedMessage: PropTypes.string.isRequired,
};

/** لینک‌های گوگل‌مپ و نشان موقعیت متقاضی با دکمه کپی و باز کردن. */
const LocationLinkCopy = ({ xPoint, yPoint, size = "small" }) => {
  const googleLink = buildGoogleMapsLink(xPoint, yPoint);
  if (!googleLink) return null;
  const neshanLink = buildNeshanLink(xPoint, yPoint);

  return (
    <Box sx={{ display: "grid", gap: 1.5 }}>
      <LinkRow
        label="لینک لوکیشن (گوگل‌مپ)"
        link={googleLink}
        size={size}
        copiedMessage="لینک گوگل‌مپ کپی شد."
      />
      <LinkRow
        label="لینک لوکیشن (نشان)"
        link={neshanLink}
        size={size}
        copiedMessage="لینک نشان کپی شد."
      />
    </Box>
  );
};

LocationLinkCopy.propTypes = {
  xPoint: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  yPoint: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  size: PropTypes.string,
};

export default LocationLinkCopy;
